import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { CountrydetailpageService } from '../countrydetailpage.service';
import { CommonModule } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-country-detail-other-features',
  templateUrl: './country-detail-other-features.component.html',
  styleUrls: ['./country-detail-other-features.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
})
export class CountryDetailOtherFeaturesComponent implements OnInit, OnDestroy {
  @Input() pageData: any;
  queryParams: any;
  constructor(
    private contentful: ContentfulService,
    private countryDetailPageService: CountrydetailpageService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  featuresData: any;

  ngOnInit(): void {
    
  }
  ngOnChanges(): void {
    if (!this.pageData) return;
    const data = this.pageData;
    if (data != null && data.features && data.features.length >= 4 && data.features[3]?.fields) {
      this.featuresData = {
        header: data.features[3].fields.title,
        cards: data.features[3].fields.component1,
      };
    }
  }
}
